export const PrivateSpaces = 'Private Spaces';
export const RoomOptions = 'Room Options';
